<template>
  <div aria-live="assertive" class="pointer-events-none fixed inset-0 z-[120] flex items-end px-4 py-6 sm:p-6">
    <TransitionGroup tag="div" class="flex w-full flex-col items-center gap-3 sm:items-end"
      enter-active-class="transform transition duration-200 ease-out"
      enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
      enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
      leave-active-class="transform transition duration-150 ease-in" leave-from-class="translate-y-0 opacity-100"
      leave-to-class="translate-y-1 opacity-0 sm:translate-y-0 sm:translate-x-2">
      <Toast v-for="toastItem in toastsStore.items" :key="toastItem.id" :toast="toastItem"
        @close="toastsStore.remove(toastItem.id)" @action="runAction(toastItem, $event)" />
    </TransitionGroup>
  </div>
</template>

<script>
import { useToastsStore } from '@/stores/toasts'
import Toast from '@/components/toasts/Toast.vue'

export default {
  components: {
    Toast,
  },
  computed: {
    toastsStore() {
      return useToastsStore()
    },
  },
  methods: {
    runAction(toastItem, action) {
      if (typeof action?.onClick === 'function') {
        action.onClick(toastItem)
      }

      if (action?.closeOnClick !== false) {
        this.toastsStore.remove(toastItem.id)
      }
    },
  },
}
</script>
